export const ENV = process.env.REACT_APP_API_ENV;
const javaHost = {
  // dev:"http://192.168.10.243:9090/mock/218", // mock
  dev: "https://dev-gateway.fxqifu.net/pangu", // 测试环境dev

  test: "https://qa-gateway.fxqifu.net/pangu", // 测试环境qa
  prod: "https://gateway.fxqifu.net/pangu", // 线上
};

const phpHost = {
  dev: 'http://manager.koudaiqifu.cn',
  test: 'http://manager.koudaiqifu.cn',
  prod: 'https://manager.fxqifu.com'
}

const previewShopHost_PC = {
  dev: "http://dev-deco.fleshopy.com", // 测试环境dev
  test: "http://qa-deco.fleshopy.com", // 测试环境qa
  prod: "https://deco.fleshopy.com", // 线上
};

const previewShopHost_Mobile = {
  dev: "http://dev-preview.fleshopy.com/index", // 测试环境dev
  test: "http://qa-preview.fleshopy.com/index", // 测试环境qa
  prod: "https://preview.fleshopy.com/index", // 线上
};
const SiteHost = {
  dev: "http://dev-site.fleshopy.com", // 测试环境dev
  test: "http://qa-site.fleshopy.com", // 测试环境qa
  prod: "http://site.fleshopy.com", // 线上
};

const previewH5_Mobile = {
  dev: "dev-shop.fleshopy.com/index", //测试环境dev
  test: "qa-shop.fleshopy.com/index", //测试环境qa
  prod: "shop.fleshopy.com/index", //线上
};
const fleCard = {
  dev: "http://dev-www.peliten.com/card-fitment/fitment",
  test: "https://qa-www.peliten.com/card-fitment/fitment",
  prod: "http://www.peliten.com/card-fitment/fitment",
};

const GOODS_HOST = {
  dev: "http://dev-goods.peliten.com/goods",
  test: "https://qa-goods.peliten.com/goods",
  prod: "https://goods.peliten.com/goods",
};

export const GOODS_MAIN_HOST = GOODS_HOST[ENV];

const INTELLIGENT_HOST = {
  dev: "http://dev-yunying.fxqifu.com/intelligent",
  test: "https://qa-yunying.fxqifu.com/intelligent",
  prod: "https://yunying.fxqifu.com/intelligent",
};

export const INTELLIGENT_MAIN_HOST = INTELLIGENT_HOST[ENV];

const YUN_YING_HOST = {
  dev: "http://dev-yunying.fxqifu.com/",
  test: "https://qa-yunying.fxqifu.com/",
  prod: "https://yunying.fxqifu.com/",
};
export const YUN_YING_MAIN_HOST = YUN_YING_HOST[ENV];

const YUN_YING__SIMPLE_HOST = {
  dev: "dev-yunying.fxqifu.com",
  test: "qa-yunying.fxqifu.com",
  prod: "yunying.fxqifu.com",
};

const WEBSITE_DECORATION_HOST_MAP = {
  dev: "http://dev-deco.flesaas.com",
  test: "https://qa-deco.flesaas.com",
  prod: "https://deco.flesaas.com",
};
export const WEBSITE_DECORATION_HOST=WEBSITE_DECORATION_HOST_MAP[ENV];


const MALL_HOST_MAP = {
  dev: "http://dev-www.elebuys.com",
  test: "https://qa-www.elebuys.com",
  prod: "https://mall.fxqifu.com",
};
export const MALL_HOST_MAP_HOST=MALL_HOST_MAP [ENV];


export const WEBSITE_HOST_MAP = {
  dev: "http://xxxxxx.dev-site.flesaas.com",
  test: "https://xxxxxx.qa-site.flesaas.com",
  prod: "https://xxxxxx.site.flesaas.com",
};
export const GET_WEBSITE_HOST = (str = '') => {
  return WEBSITE_HOST_MAP[ENV].replace('xxxxxx', str)
}

export const YUN_YING__SIMPLE_MAIN_HOST = YUN_YING__SIMPLE_HOST[ENV];

export const mainHost3 = SiteHost[ENV];
export const mainHost1 = javaHost[ENV];
export const mainHost5 = phpHost[ENV]; // 增加php的域名设置
export const mainHost4 = fleCard[ENV];
export const mainPreviewShopHost = previewShopHost_PC[ENV];
export const mainPreviewShopHost_Mobile = previewShopHost_Mobile[ENV];
export const mainpreviewH5_Mobile = previewH5_Mobile[ENV];

export const DATA_CODE = {
  SUCCESS: 2000,
  QUERY_PARAMS_ERROR: 3000,
  LOGIN_ERROR: "100003",
  OTHER_ERROR: 5000,
};


export const BASE_ROUTER ='/panguOperate';
